export function StoreDB () {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("pos", 1);

    request.onerror = () => {
      reject("DB cannot open");
    };

    request.onupgradeneeded = (e) => {
      const db = e.target.result;

      // products
      if (!db.objectStoreNames.contains("products")) {
        const store = db.createObjectStore("products", {keyPath: "id"});
        store.createIndex("categoryID", "categoryId", { unique: false });
        store.createIndex("barcode", "meta.barcode", { unique: false });
        store.createIndex("asynchronous", "async.status", { unique: false });
        store.createIndex("productName", "nameProudct", { unique: true });
      }

      if (!db.objectStoreNames.contains("batches")) {
          const store = db.createObjectStore("batches", { keyPath: "id" });
          store.createIndex("productId", "productId", { unique: false });
          store.createIndex("batchIndex", "index", { unique: false });
          store.createIndex("inventoryId", "invId", { unique: false });
      }

      if (!db.objectStoreNames.contains("transactionBatch")) {
          const store = db.createObjectStore("transactionBatch", { keyPath: "id" });
          store.createIndex("batchId", "batchId", { unique: false });
      }

      if (!db.objectStoreNames.contains("suppliers")) {
          db.createObjectStore("suppliers", { keyPath: "id" });
      }

      // invoices
      if (!db.objectStoreNames.contains("invoices")) {
        const store = db.createObjectStore("invoices", { keyPath: "id" });
        store.createIndex("orderNum", "order_number", { unique: false });
        store.createIndex("endDay", "end_day", { unique: false });
        store.createIndex("asynchronous", "async.status", { unique: false });
      }
      
      // categories
      if (!db.objectStoreNames.contains("categories")) {
        db.createObjectStore("categories", { keyPath: "id" });
      }
      
      // transactions
      if (!db.objectStoreNames.contains("transactions")) {
        const store = db.createObjectStore("transactions", { keyPath: "id" });
        store.createIndex("asynchronous", "async.status", { unique: false });
      }
      // sales
      if (!db.objectStoreNames.contains("sales")) {
        const store = db.createObjectStore("sales", { keyPath: "id" });
        store.createIndex("asynchronous", "async.status", { unique: false });
      }

      // employees
      if (!db.objectStoreNames.contains("employees")) {
        const store = db.createObjectStore("employees", { keyPath: "code" });
        store.createIndex("user", "user", { unique: false });
      }

      // schedule
      if (!db.objectStoreNames.contains("schedule")) {
        const store = db.createObjectStore("schedule", { keyPath: "id" });
        store.createIndex("code", "code", { unique: false });
        store.createIndex("date", "today", { unique: false });
        store.createIndex("asynchronous", "async.status", { unique: false });
      }

      // clientinfo
      if (!db.objectStoreNames.contains("clientinfo")) {
        const store = db.createObjectStore("clientinfo", { keyPath: "phone_number" });
        store.createIndex("asynchronous", "async.status", { unique: false });
      }
      // settings   
      if (!db.objectStoreNames.contains("settings")) {
        db.createObjectStore("settings", { keyPath: "label" });
      }
      // warehouse
      if (!db.objectStoreNames.contains("warehouse")) {
        const store = db.createObjectStore("warehouse", { keyPath: "id" });
        store.createIndex("name", "nameWareHouse", {unique: false});
        store.createIndex("asynchronous", "async.status", { unique: false });
      }
      // history
      if (!db.objectStoreNames.contains("history")) {
        const store = db.createObjectStore("history", { keyPath: "id" });
        store.createIndex("asynchronous", "async.status", { unique: false });
      }
    };

    request.onsuccess = () => {
      resolve(request.result);
    };
  });
}

export const deleteDatabase = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.deleteDatabase("pos");

    request.onsuccess = () => resolve("Database deleted");

    request.onerror = () => reject("Error deleting database");

    request.onblocked = () => {
      console.log("Close other tabs using this database");
    };
  });
};

export function showTables() {
  return new Promise(async (resolve, reject) => {
    try {
      const db = await StoreDB();

      const tables = Array.from(db.objectStoreNames);

      if (!tables.length) {
        resolve(0);
      } else {
        resolve(tables);
      }

    } catch (error) {
      reject("something error when show tables");
    }
  });
}

export const recodeNow = (newProduct, tableName) => {
    return new Promise(async (resolve, reject) => {
        try {
            const db = await StoreDB();
            const tx = db.transaction(tableName, "readwrite");
            const store = tx.objectStore(tableName);

            const request = store.add(newProduct);

            request.onsuccess = () => {
                resolve("Product saved successfully");
            };

            request.onerror = (event) => {
              reject(new Error(event.target.error));
            };

            // اختياري: تتأكد إن الـ transaction خلص
            // tx.oncomplete = () => console.log("Transaction complete");
            tx.onerror = (e) => reject("Transaction error: " + e);

        } catch (error) {
            reject("DB open error: " + error);
        }
    });
}

function getValueByPath(obj, path) {
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
}

export function getAllIds(storeName) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("pos");

    request.onsuccess = function () {
      const db = request.result;

      if (!db.objectStoreNames.contains(storeName)) {
        db.close();
        return reject("Store not found");
      }

      const tx = db.transaction(storeName, "readonly");
      const store = tx.objectStore(storeName);

      const getAllReq = store.getAll();

      getAllReq.onsuccess = () => {
        const data = getAllReq.result;
        const keyPath = store.keyPath;

        const ids = data.map(item => {
          if (typeof keyPath === "string") {
            return getValueByPath(item, keyPath);
          }

          // لو array keyPath
          if (Array.isArray(keyPath)) {
            return keyPath.map(k => getValueByPath(item, k));
          }

          return item || [];
        });

        db.close();
        resolve(ids);
      };

      getAllReq.onerror = () => reject(getAllReq.error);
    };

    request.onerror = () => reject(request.error);
  });
}

export const update = (tableName, newData) => {
    return new Promise(async (resolve, reject) => {
        try {
            const db = await StoreDB();
            const tx  = db.transaction(tableName, "readwrite");
            const store = tx.objectStore(tableName);

            const request = store.put(newData);
            request.onsuccess = () => {
                resolve("updated successfully");
            }

            request.onerror = (err) => {
                reject(err);
            }

        }
        catch(error) {
            reject(error);
        }
    })
} 

export const displayData = (tableName, page = null, limit = null) => {
    return new Promise(async (resolve, reject) => {
        const allData = [];
        const hasPagination = page !== null && limit !== null;

        const offset = hasPagination ? (page - 1) * limit : 0;
        let index = 0;

        try {
            const db = await StoreDB();
            const tx = db.transaction(tableName, "readonly");
            const table = tx.objectStore(tableName);

            const cursorRequest = table.openCursor();

            cursorRequest.onerror = (error) => reject(error);

            cursorRequest.onsuccess = (e) => {
                const cursor = e.target.result;

                if (cursor) {
                    if (
                        !hasPagination || 
                        (index >= offset && allData.length < limit)
                    ) {
                        allData.push(cursor.value);
                    }

                    index++;

                    // لو pagination شغالة وخلصنا limit نوقف
                    if (hasPagination && allData.length === limit) {
                        resolve(allData);
                        return;
                    }

                    cursor.continue();
                } else {
                    resolve(allData.length ? allData : null);
                }
            };
        } catch (error) {
            reject(error);
        }
    });
};

// this is search with primary key
export const mainSearch = async (tableName, item) => {
    const db = await StoreDB();

    // تأكد أولًا من وجود Object Store
    if(!db.objectStoreNames.contains(tableName)) {
        throw new Error(`Object store "${tableName}" not found`);
    }

    const tx = db.transaction(tableName, "readonly");
    const store = tx.objectStore(tableName);

    return new Promise((resolve, reject) => {
        const request = store.get(item);

        request.onsuccess = (e) => {
            const result = e.target.result;
            resolve(result || null);
        };

        request.onerror = (err) => reject(err);
    });
};

export const secondarySearch = async (
  tableName,
  indexName,
  value,
  page = null,
  limit = null
) => {
  const db = await StoreDB();

  if (!db.objectStoreNames.contains(tableName)) {
    throw new Error(`Object store "${tableName}" not found`);
  }

  const tx = db.transaction(tableName, "readonly");
  const store = tx.objectStore(tableName);
  const index = store.index(indexName);

  let results = [];

  return new Promise((resolve, reject) => {
    const request = index.openCursor(IDBKeyRange.only(value));

    let skip = 0;
    if (page && limit) {
      skip = (page - 1) * limit;
    }

    request.onsuccess = (e) => {
      const cursor = e.target.result;

      // خلصنا البيانات
      if (!cursor) {
        return resolve(results.length ? results : []);
      }

      // 🚀 لو عايز كل البيانات
      if (!page || !limit) {
        results.push(cursor.value);
        cursor.continue();
        return;
      }

      // 🚀 skip مرة واحدة بس (أسرع)
      if (skip > 0) {
        cursor.advance(skip);
        skip = 0;
        return;
      }

      // 🚀 جمع limit
      if (results.length < limit) {
        results.push(cursor.value);
        cursor.continue();
      } else {
        resolve(results);
      }
    };

    request.onerror = (err) => reject(err);
  });
};

//  هعمل function تدور ب include 
export const semiSearch = async (tableName, item, key) => {
    const db = await StoreDB();

    if (!db.objectStoreNames.contains(tableName)) {
        throw new Error(`Object store "${tableName}" not found`);
    }

    const tx = db.transaction(tableName, "readonly");
    const store = tx.objectStore(tableName);

    return new Promise((resolve, reject) => {
        const request = store.getAll();

        request.onsuccess = (e) => {
            const results = e.target.result;

            const searchValue = item?.toString().toLowerCase() || "";

            const filtered = results.filter((data) => {
              const value = data?.[key]?.toString().toLowerCase() || [];
                return value.includes(searchValue);
            });
            resolve(filtered);
        };

        request.onerror = (err) => reject(err);
    });
};

export const deleteItem = async (tableName, id) => {
    const db = await StoreDB();
    const tx = db.transaction(tableName, "readwrite");
    const store = tx.objectStore(tableName);

    store.delete(id);

    return new Promise((resolve, reject) => {
        tx.oncomplete = () => resolve(true);
        tx.onerror = () => reject(tx.error);
        tx.onabort = () => reject(tx.error);
    });
};

export const queueNum = async () => {
  const db = await StoreDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction("invoices", "readonly");
    const store = tx.objectStore("invoices");

    if (!store.indexNames.contains("endDay")) {
      reject("index endDay not found");
      return;
    }

    const index = store.index("endDay");
    const req = index.count('f');

    req.onsuccess = () => {
      const count = req.result;
      resolve(count === 0 ? 1 : count + 1);
    };

    req.onerror = () => reject(1);
  });
};

// count docs
export const countStore = async (storeName) => {
    const db = await StoreDB();

    return new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, "readonly");
        const store = tx.objectStore(storeName);

        const request = store.count();

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject("Count failed");
    });
};